export default function ProcessRecoveryFunctionController(
  $q,
  $scope,
  $timeout,

  focus
) {
  const vm = this;

  vm.function.hasRecoveryProcedureOld = vm.function.hasRecoveryProcedure;
  vm.function.recoveryProcedureTextOld = vm.function.recoveryProcedureText;

  vm.canExpand = vm.function.hasRecoveryProcedure;
  vm.isExpanded = false;

  vm.handleExpandProcessRecoveryFunction = _handleExpandProcessRecoveryFunction;
  vm.handleHasRecoveryProcedureChange = _handleHasRecoveryProcedureChange;

  function _handleExpandProcessRecoveryFunction() {
    if (vm.isEditable || vm.function.hasRecoveryProcedure) {
      vm.isExpanded = !vm.isExpanded;
      if (
        !vm.function.hasRecoveryProcedure
        && vm.isEditable
      ) {
        vm.function.hasRecoveryProcedure = true;
        vm.canExpand = true;
        focus(`txtProcessRecoveryFunction${vm.function.functionId}RecoveryProcedure`);
      }
    }
    _resizeTextareas();
  }

  function _handleHasRecoveryProcedureChange() {
    vm.canExpand = vm.function.hasRecoveryProcedure;
    if (vm.canExpand) {
      vm.isExpanded = true;
      focus(`txtProcessRecoveryFunction${vm.function.functionId}RecoveryProcedure`);
    } else {
      vm.isExpanded = false;
    }
    _resizeTextareas();
  }

  function _resizeTextareas() {
    $timeout(
      () => {
        $scope.$broadcast('md-resize-textarea');
      },
      0
    );
  }
}

ProcessRecoveryFunctionController.$inject = [
  '$q',
  '$scope',
  '$timeout',

  'focus'
];
